export default Object.freeze({
    badRequest: 400,
    unauthorised: 401,
    forbidden: 403,
    notFound: 404,
    internalServerError: 500
});
